import _slicedToArray from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Tone } from "../Tone";
import { optionsFromArguments } from "../util/Defaults";
import { noOp } from "../util/Interface";
import { isString } from "../util/TypeCheck";
import { ToneAudioBuffer } from "./ToneAudioBuffer";
import { assert } from "../util/Debug";
/**
 * A data structure for holding multiple buffers in a Map-like datastructure.
 *
 * @example
 * const pianoSamples = new Tone.ToneAudioBuffers({
 * 	A1: "https://tonejs.github.io/audio/casio/A1.mp3",
 * 	A2: "https://tonejs.github.io/audio/casio/A2.mp3",
 * }, () => {
 * 	const player = new Tone.Player().toDestination();
 * 	// play one of the samples when they all load
 * 	player.buffer = pianoSamples.get("A2");
 * 	player.start();
 * });
 * @example
 * // To pass in additional parameters in the second parameter
 * const buffers = new Tone.ToneAudioBuffers({
 * 	 urls: {
 * 		 A1: "A1.mp3",
 * 		 A2: "A2.mp3",
 * 	 },
 * 	 onload: () => console.log("loaded"),
 * 	 baseUrl: "https://tonejs.github.io/audio/casio/"
 * });
 * @category Core
 */

export var ToneAudioBuffers = /*#__PURE__*/function (_Tone) {
  _inherits(ToneAudioBuffers, _Tone);

  var _super = _createSuper(ToneAudioBuffers);

  function ToneAudioBuffers() {
    var _this;

    _classCallCheck(this, ToneAudioBuffers);

    _this = _super.call(this);
    _this.name = "ToneAudioBuffers";
    /**
     * All of the buffers
     */

    _this._buffers = new Map();
    /**
     * Keep track of the number of loaded buffers
     */

    _this._loadingCount = 0;
    var options = optionsFromArguments(ToneAudioBuffers.getDefaults(), arguments, ["urls", "onload", "baseUrl"], "urls");
    _this.baseUrl = options.baseUrl; // add each one

    Object.keys(options.urls).forEach(function (name) {
      _this._loadingCount++;
      var url = options.urls[name];

      _this.add(name, url, _this._bufferLoaded.bind(_assertThisInitialized(_this), options.onload), options.onerror);
    });
    return _this;
  }

  _createClass(ToneAudioBuffers, [{
    key: "has",
    value:
    /**
     * True if the buffers object has a buffer by that name.
     * @param  name  The key or index of the buffer.
     */
    function has(name) {
      return this._buffers.has(name.toString());
    }
    /**
     * Get a buffer by name. If an array was loaded,
     * then use the array index.
     * @param  name  The key or index of the buffer.
     */

  }, {
    key: "get",
    value: function get(name) {
      assert(this.has(name), "ToneAudioBuffers has no buffer named: ".concat(name));
      return this._buffers.get(name.toString());
    }
    /**
     * A buffer was loaded. decrement the counter.
     */

  }, {
    key: "_bufferLoaded",
    value: function _bufferLoaded(callback) {
      this._loadingCount--;

      if (this._loadingCount === 0 && callback) {
        callback();
      }
    }
    /**
     * If the buffers are loaded or not
     */

  }, {
    key: "loaded",
    get: function get() {
      return Array.from(this._buffers).every(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ = _ref2[0],
            buffer = _ref2[1];

        return buffer.loaded;
      });
    }
    /**
     * Add a buffer by name and url to the Buffers
     * @param  name      A unique name to give the buffer
     * @param  url  Either the url of the bufer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     * @param  onerror  Invoked if the buffer can't be loaded
     */

  }, {
    key: "add",
    value: function add(name, url) {
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noOp;
      var onerror = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noOp;

      if (isString(url)) {
        this._buffers.set(name.toString(), new ToneAudioBuffer(this.baseUrl + url, callback, onerror));
      } else {
        this._buffers.set(name.toString(), new ToneAudioBuffer(url, callback, onerror));
      }

      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ToneAudioBuffers.prototype), "dispose", this).call(this);

      this._buffers.forEach(function (buffer) {
        return buffer.dispose();
      });

      this._buffers.clear();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return {
        baseUrl: "",
        onerror: noOp,
        onload: noOp,
        urls: {}
      };
    }
  }]);

  return ToneAudioBuffers;
}(Tone);